// extracted by mini-css-extract-plugin
export var active = "style-mod--active--0fd8b";
export var img = "style-mod--img--70818";
export var list = "style-mod--list--0a487";
export var singleCell = "style-mod--single-cell--8ae5f";
export var sizesContainer = "style-mod--sizes-container--18890";